// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2-vMm","menuToggle":"Menu_menuToggle__1BwIJ","item":"Menu_item__3nVEA","arrow":"Menu_arrow__3m0TA"};